module.exports = __webpack_public_path__ + "img/detail-background.8b01d5e8.png";